export const translations = {
  originUf: {
    pt: 'UF de origem',
    en: 'Source UF',
    es: 'UF de origen',
    de: 'UF Ursprung',
  },
  originCity: {
    pt: 'Cidade de origem',
    en: 'Source city',
    es: 'Ciudad de origen',
    de: 'Ursprungsstadt',
  },
  originLatitude: {
    pt: 'Latitude de origem',
    en: 'Source latitude',
    es: 'Latitud de origen',
    de: 'Breitengrad der Quelle',
  },
  originLongitude: {
    pt: 'Longitude de origem',
    en: 'Source longitude',
    es: 'Longitud de origen',
    de: 'Längengrad der Quelle',
  },
  destinationUf: {
    pt: 'UF de destino',
    en: 'Destination UF',
    es: 'UF de destino',
    de: 'UF Ziel',
  },
  destinationCity: {
    pt: 'Cidade de destino',
    en: 'Destination city',
    es: 'Ciudad de destino',
    de: 'Zielstadt',
  },
  destinationLatitude: {
    pt: 'Latitude de destino',
    en: 'Destination latitude',
    es: 'Latitud de destino',
    de: 'Breitengrad des Ziels',
  },
  destinationLongitude: {
    pt: 'Longitude de destino',
    en: 'Destination longitude',
    es: 'Longitud de destino',
    de: 'Längengrad des Ziels',
  },
}